<template>
<!--  园区能耗-->
    <div class="energy">
        <Title :info="waterTitle"/>
      <div class="water" ref="waterEcharts"></div>
      <Title :info="usageTitle"/>
      <div class="usage" ref="usageLine"></div>
      <Title :info="conditionerTitle"/>
      <div class="conditioner">
        <div class="first">
          <span>设备编号</span>
          <span>设备类型</span>
          <span>设备位置</span>
          <span>设备状态</span>
        </div>

        <div class="div-list" v-for="(item,i) in conditionerList" :key="i">
          <span>{{item.number}}</span>
          <span>{{item.type}}</span>
          <span>{{item.position}}</span>
          <span v-if="item.state=='离线'" style="color: #ffa710">{{item.state}}</span>
          <span v-else style="color: #00fff6">{{item.state}}</span>
        </div>
      </div>
      <Title :info="elevatorTitle"/>
      <div class="elevator-box">
        <div class="elevator-left">
          <div class="elevator-echarts" ref="elevator"></div>
          <p>52</p>
          <span>（告警总数）（台）</span>
        </div>
        <div class="elevator-right">
          <div class="elevator-list">
            <div class="ico"></div>
            <span>已完成</span>
            <span>55%</span>
            <span>12</span>
          </div>
          <div class="elevator-list">
            <div class="ico" style="background: #0296fc"></div>
            <span>待处理</span>
            <span>48%</span>
            <span>14</span>
          </div>
          <div class="elevator-list">
            <div class="ico" style="background: #8cdeff"></div>
            <span>处理中</span>
            <span>32%</span>
            <span>08</span>
          </div>
        </div>
      </div>
      <div class="energy-list">
        <div class="list-box" v-for="(item,i) in list" :key="i" @click="chanageDay(i)">
          <img :class="item.flag?'ico active':'ico'" :src="item.ico.icoImg" :width="item.ico.width" :height="item.ico.height">
          <div :class="item.flag?'ico-box active':'ico-box'"></div>
          <P>{{item.text}}</P>
        </div>
      </div>
    </div>
</template>

<script>
  import 'echarts-gl'
  import Title from "@/components/Title";
  import {usageLine,elevatorEcharts,water} from './../../public/utils/echarts'
  import {EleResize} from './../../public/utils/esresize'
export default {
  name: 'ParkenergyView',
  components: {
    Title
  },
  data(){
    return{
      waterTitle: {
        ico: require('./../assets/water-supply.png'),
        text: '日供水',
        english: 'Daily water supply',
        width: 16,
        height: 20
      },
      usageTitle:{
        ico: require('./../assets/usage.png'),
        text: '用电数据',
        english: 'Electricity usage data',
        width: 14,
        height: 24
      },
      conditionerTitle:{
        ico: require('./../assets/conditioner.png'),
        text: '空调设备',
        english: 'air conditioning',
        width: 17,
        height: 20
      },
      elevatorTitle:{
        ico: require('./../assets/elevator.png'),
        text: '电梯告警',
        english: 'Elevator Alarm',
        width: 16,
        height: 20
      },
      conditionerList:[
        {
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'离线'
        },{
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'开启'
        },{
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'开启'
        },{
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'开启'
        },{
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'开启'
        },{
          number:'000154',
          type:'分体空调',
          position:'2号楼',
          state:'开启'
        }
      ],
      list:[
        {
          ico:{
            icoImg:require("./../assets/water-supply1.png"),
            width:'30',
            height:'37'
          },
          flag:false,
          icoTrue:{
            icoImg:require("./../assets/water-supply-active.png"),
            width:'36',
            height:'43'
          },
          icoFalse:{
            icoImg:require("./../assets/water-supply1.png"),
            width:'30',
            height:'37'
          },
          text:'供水'
        },
        {
          ico:{
            icoImg:require("./../assets/heating.png"),
            width:'29',
            height:'29'
          },
          flag:false,
          icoTrue:{
            icoImg:require("./../assets/heating-active.png"),
            width:'35',
            height:'35'
          },
          icoFalse:{
            icoImg:require("./../assets/heating.png"),
            width:'29',
            height:'29'
          },
          text: '供暖'
        },
        {
          ico:{
            icoImg:require("./../assets/power-supply.png"),
            width:'24',
            height:'32'
          },
          flag:false,
          icoTrue:{
            icoImg:require("./../assets/power-supply-active.png"),
            width:'30',
            height:'38'
          },
          icoFalse:{
            icoImg:require("./../assets/power-supply.png"),
            width:'24',
            height:'32'
          },
          text: '供电'
        },
        {
          ico:{
            icoImg:require("./../assets/elevator.png"),
            width:'27',
            height:'22'
          },
          flag:false,
          icoTrue:{
            icoImg:require("./../assets/elevator-active.png"),
            width:'32',
            height:'28'
          },
          icoFalse:{
            icoImg:require("./../assets/elevator.png"),
            width:'27',
            height:'22'
          },
          text: '电梯'
        },
        {
          ico:{
            icoImg:require("./../assets/air-conditioner.png"),
            width:'29',
            height:'22'
          },
          flag:false,
          icoTrue:{
            icoImg:require("./../assets/air-conditioner-active.png"),
            width:'35',
            height:'28'
          },
          icoFalse:{
            icoImg:require("./../assets/air-conditioner.png"),
            width:'29',
            height:'22'
          },
          text: '空调'
        }
      ],
      activeInx:-1
    }
  },
  mounted() {
    this.drawLine1();
    this.drawLine2();
    this.drawLine3();
    window.parkenergyViewCancel = this.parkenergyViewCancel;
  },
  methods:{
    drawLine1() {
      let option = usageLine();
      let myChart = this.$echarts.init(this.$refs.usageLine);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.usageLine, listener);
    },
    drawLine2() {
      let option = elevatorEcharts();
      let myChart = this.$echarts.init(this.$refs.elevator);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.elevator, listener);
    },
    drawLine3() {
      let option = water();
      let myChart = this.$echarts.init(this.$refs.waterEcharts);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.waterEcharts, listener);
    },
    parkenergyViewCancel(){
      if(this.list[0].flag||this.list[1].flag||this.list[2].flag){
        document.getElementById('iframe').contentWindow.MMAPI.provide(3)
      }else if (this.list[3].flag) {
        document.getElementById('iframe').contentWindow.MMAPI.elevator(1)
      }
      for(let i = 0;i<this.list.length;i++){
        if(this.list[i].flag){
          this.list[i].flag = !this.list[i].flag;
          this.list[i].ico =this.list[i].icoFalse
        }
      }

    },
    chanageDay(num){

      this.list[num].flag = !this.list[num].flag;
      for(let i = 0;i < this.list.length;i++){
        if(i==num){

          if(this.list[num].flag){
            this.list[i].ico = this.list[i].icoTrue
          }else {
            this.list[i].ico = this.list[i].icoFalse
          }

        }else {
          this.list[i].flag = false;
          this.list[i].ico = this.list[i].icoFalse
        }
      }
      switch (num) {
        case 0:
            if(this.list[num].flag){
              // this.canclePark(this.activeInx);
              this.activeInx = num;
              document.getElementById('iframe').contentWindow.MMAPI.provide(2)
            }else {
              document.getElementById('iframe').contentWindow.MMAPI.provide(3)
            }


          break;
        case 1:
          if(this.list[num].flag) {
            // this.canclePark(this.activeInx);
            this.activeInx = num;
            document.getElementById('iframe').contentWindow.MMAPI.provide(1)
          }else {
            document.getElementById('iframe').contentWindow.MMAPI.provide(3)
          }
          break;
        case 2:
          if(this.list[num].flag) {
            // this.canclePark(this.activeInx);
            this.activeInx = num;
            document.getElementById('iframe').contentWindow.MMAPI.provide(0)
          }else {
            document.getElementById('iframe').contentWindow.MMAPI.provide(3)
          }
          break;
        case 3:

            if(this.list[num].flag){
              // this.canclePark(this.activeInx);
              this.activeInx = num;

              document.getElementById('iframe').contentWindow.MMAPI.elevator(0)
            }else {
              document.getElementById('iframe').contentWindow.MMAPI.elevator(1)
            }
          break;
        case 4:
          document.getElementById('iframe').contentWindow.MMAPI.provide(3)
          document.getElementById('iframe').contentWindow.MMAPI.elevator(1)
          break;
      }
    }
  }
}
</script>

<style scoped lang="less">
  .energy{
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 12px;
    .water{
      margin: 0 auto;
      margin-top: 10vh*0.0926;
      margin-bottom: 9vh*0.0926;
      width: 332px;
      height: 200vh*0.0926;

      box-sizing: border-box;
    }
    .usage{
      width: 339px;
      height: 185vh*0.0926;
      margin: 0 auto;

      margin-top: 8vh*0.0926;
      margin-bottom: 10vh*0.0926;
    }
    .conditioner{
      width: 100%;
      height: 225vh*0.0926;
      padding: 0 4px;
      box-sizing: border-box;
      margin: 16vh*0.0926 0;

      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .first{
        color: #fff;
        display: flex;
        span{
          display: flex;
          width: 25%;
          align-items: center;
          justify-content: center;
        }
      }
      .div-list{
        width: 100%;
        display: flex;
        color: #b6b6b6;
        height: 26vh*0.0926;
        justify-content: center;
        &:nth-of-type(odd){
            background-color: rgba(255, 255, 255,0.2);

        }
        span{
          display: flex;
          width: 25%;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .elevator-box{
      width: 100%;
      padding: 0 25px;
      box-sizing: border-box;
      height: 148vh*0.0926;
      margin-top: 16vh*0.0926;
      display: flex;
      justify-content: space-around;
      .elevator-left{
        width: 134px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .elevator-echarts{
          height: 103vh*0.0926;
          width: 100%;
          position: relative;
          &:after{
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            background: url("./../assets/elevator-bg.png") no-repeat;
            background-size: 100% 100%;
            width: 100%;
            height: 100%;
            pointer-events: none;
          }
        }
        p{
          font-size: 24px;
          font-weight: bold;

          color: transparent;
          background-image: linear-gradient(#ffffff, #c17e14);
          -webkit-background-clip: text;
        }
        span{
          color: rgba(255, 255, 255, 0.502);

        }
      }
      .elevator-right{
        margin-top: 8px;
        width: 160px;
        height: 95vh*0.0926;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .elevator-list{
          height: 20vh*.0926;
          width: 100%;
          display: flex;
          align-items: center;
          background-color: rgba(255, 255, 255,0.2);
          padding: 0 8px;
          box-sizing: border-box;
          justify-content: space-between;
          .ico{
            background-color: rgb(255, 167, 16);
            width: 7px;
            height: 7px;

          }
          span{

          }
        }
      }
    }
    .energy-list{
      position: fixed;
      left: 506px;
      bottom: 67vh * 0.0926;
      display: flex;
      align-items: center;
      width: 785px;/*no*/
      justify-content: space-between;
      .list-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        height: 73px;/*no*/
        width: 75px;/*no*/
        cursor: pointer;
        &:nth-of-type(1){
          .ico{
            margin-top: 0px;/*no*/
            &.active{
              margin-top: -3px;/*no*/
            }
          }
        }
        &:nth-of-type(2){
          .ico{
            margin-top: 5px;/*no*/
            &.active{
              margin-top: 2px;/*no*/
            }
          }
        }
        &:nth-of-type(3){
          .ico{
            margin-top: 5px;/*no*/
            &.active{
              margin-top: 2px;/*no*/
            }
          }
        }
        &:nth-of-type(4){
          .ico{
            margin-top: 11px;/*no*/
            &.active{
              margin-top: 8px;/*no*/
            }
          }
        }
        &:nth-of-type(5){
          .ico{
            margin-top: 15px;/*no*/
            &.active{
              margin-top: 12px;/*no*/
            }
          }
        }
        .ico-box{
          background: url("./../assets/ico-box.png") no-repeat;
          background-size: 100% 100%;
          width: 75px;/*no*/
          height: 35px;/*no*/
          position: absolute;
          top: 20px;
          &.active{
            background: url("./../assets/ico-box-active.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        p{
          font-size: 14px;/*no*/
          margin-top: 6px;/*no*/
        }
      }

    }
  }
</style>
